<!--美育浸润-->
<template>
    <div class="guide-nav-content" >
        <div class="guide-ext-container" v-show="videoMode==='beautyEdu'">
            <div class="head-container">
                <div class="left-head-container" @click="backReadMuseum">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">美育浸润</div>
                <div class="left-head-container">
                </div>
            </div>
            <div class="beauty-edu-container">
                <div class="beauty-edu-items">
                    <div class="beauty-edu-items-top">
                        <div class="item-top-container">
                            <div class="item-top-container-l" @click = "viewHumVideo('诗词天地','1')">
                                <div class="item-title-container">诗词天地</div>
                                <div class="item-content-container">古诗吟唱  诗词诵读  诗词鉴赏</div>
                            </div>
                            <div class="item-top-container-r" @click="viewHumVideo('经典悦读','2')">
                                <div class="item-title-container">经典悦读</div>
                                <div class="item-content-container">和你读诗  诗文素养  成语典故</div>
                            </div>
                        </div>
                    </div>
                    <div class="beauty-edu-items-bottom">
                        <div class="item-top-container">
                            <div class="item-top-container-l" @click="viewHumVideo('经典悦读','3')">
                                <div class="item-title-container">经典悦读</div>
                                <div class="item-content-container">经典美文  德育名篇  经典童谣</div>
                            </div>
                            <div class="item-top-container-r" @click="viewHumVideo('家国铸魂','4')">
                                <div class="item-title-container">家国铸魂</div>
                                <div class="item-content-container">伟人诗词  中华美德  英雄模范<br/>爱我中华歌曲  世界名曲</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--系列视频列表-->
        <div class="detail-mode" v-show="videoMode==='beautyEduInfo'">
            <beauty-videos :module-key="this.moduleKey"
                           :module-name="moduleName"
                           :mark-info="this.markInfo"
                           @back-model-page="backModelPage"/>
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import beautyVideos from "@/components/newMuseum/read/beautyVideos.vue";

export default {
    name: "beautyEdu",
    components: {beautyVideos},
    data() {
        return {
            showMode:'beautyEdu',
            serviceUrl,
            moduleName:'视频列表',
            moduleKey:'1',
            markInfo:'',
            videoMode:"beautyEdu"
        }
    },
    computed: {},
    props:{
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.showMode = 'beautyEdu';
        },

    },
    created() {
    },
    mounted(){},
    methods: {
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 8);
        },
        backReadMuseum(){
            this.videoMode = ''
            this.$emit('back-read-museum', "homePage");
        },
        viewHumVideo(name,key){
            this.moduleName = name;
            this.moduleKey = key;
            this.markInfo = new Date();
            this.showMode = 'beautyEduInfo'
            this.videoMode = 'beautyEduInfo'
        },
        backModelPage(val){
            this.videoMode = 'beautyEdu'
            this.showMode = val;
        }
    }
}

</script>

<style scoped>
.guide-nav-content{
    width: 100%;
    height: auto;
}
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}

.beauty-edu-container{
    width: 100%;
    height: calc(100% - 44px);
    align-items: center;
    justify-content: center;
    display: flex;
}

.beauty-edu-items{
    width: 100%;
    height: 360px;
    background-image: url("../../../assets/bg/my-bg.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.beauty-edu-items-top{
    width: 100%;
    height: 50%;
}

.item-top-container{
    width: 640px;
    height: 160px;
    padding-top: 20px;
    box-sizing: border-box;
    margin: auto;
    display: flex;
}

.item-top-container-l{
    width: 300px;
    height: 140px;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 10px;
    cursor: pointer;
}

.item-top-container-r{
    width: 300px;
    height: 140px;
    margin-left: 40px;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 10px;
}

.item-title-container{
    width: 100%;
    height: 80px;
    line-height: 90px;
    font-size: 18px;
    font-weight: bold;
    color: #656a82;
    text-align: center;
    cursor: pointer;
}
.item-content-container{
    width: 100%;
    height: 60px;
    font-family: sans-serif;
    font-size: 15px;
    color: #656a82;
    text-align: center;
}

.beauty-edu-items-bottom{
    width: 100%;
    height: 50%;
}

.detail-mode{
    width: 100%;
    height: auto;
}
</style>